// Formats a date string to "M/D/YYYY, H:MM AM/PM" (locale-formatted short date and hour)
export const formatDateNumericDateAndHour = (dateString?: string | null): string | null => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString(undefined, {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
}